import React from 'react'
import { connect } from 'react-redux'
import { useRoute } from 'react-router5'
import { checkPermission, UserPermission } from '../../methods/permissionByRole'
import { hasProSubscription } from '../../methods/hasProSubscription'
import 'pages/Styles/UIKit_v2.sass'

type Props = {
    $store: any
}

function ProfileContractBrandingSection({ $store }: Props) {
    const $router = useRoute()
    const user = $store.userSession
    const isPro = hasProSubscription(user)
    const isLoggedInViaRole = user?.role_id != null

    if (!checkPermission({ $store }, UserPermission.OWNER) || isLoggedInViaRole) {
        return null
    }

    return (
        <div className="profile-section-card ui-kit-v2" style={{ marginTop: 15, marginBottom: 15 }}>
            <div className="profile-section-title">Оформление страницы договора</div>
            <div className="profile-section-subtitle">
                Настройте favicon, логотип, название компании, контакты и корпоративный цвет — клиенты увидят ваш бренд
                на странице договора и при подписании.
                {!isPro && ' Доступно с подпиской Pro.'}
            </div>
            <hr className="profile-section-divider" />
            <div className="profile-section-row" style={{ marginTop: 12 }}>
                <button
                    type="button"
                    className="new ui-kit-v2-button action-button primary"
                    onClick={() => $router.router.navigate('contract-branding', {})}
                >
                    <span className="button-text">
                        {isPro ? 'Настроить оформление' : 'Открыть настройки'}
                    </span>
                </button>
            </div>
        </div>
    )
}

export default connect(
    (store) => ({ $store: store }),
)(ProfileContractBrandingSection)
